<ng-container *ngIf="navbarTopLinks">
  <div class="app-navbar-top">
    <div class="container">
      <div class="d-flex navbar-top-row flex-row justify-content-between align-items-center align-content-center">
        <div class="navbar-top-title">A company of the Mobiliar</div>

        <div class="navbar-top-list">
          <ul class="d-flex flex-row justify-content-between" style="max-height: 100%">
            <ng-container *ngFor="let navbarTopLink of navbarTopLinks; let i = index">
              <li>
                <a [routerLink]="['/' + navbarTopLink.link]">{{ navbarTopLink.label }} </a>
              </li>
            </ng-container>
            <li>
              <a
                (click)="adminService.viewType = adminService.viewType === 'userView' ? 'adminView' : 'userView'"
                [ngClass]="adminService.viewType === 'userView' ? 'user-view' : 'admin-view'"
                class="admin-view-type"
              >
                ADMIN
              </a>
            </li>
            <li>
              <a [routerLink]="['/admin/list-of-functions']" class="admin-view-type admin-view"> LIST OF FUNCTIONS </a>
            </li>

            <li>
              <div><input [(ngModel)]="adminService.jsnSourceShow" type="checkbox" /> JSON</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-container>
